import Pusher from "pusher-js";
import { envIsLocal } from "@/plugins/env";

Pusher.logToConsole = envIsLocal;

export default new Pusher(process.env.VUE_APP_PUSHER_APP_KEY, {
    cluster: process.env.VUE_APP_PUSHER_CLUSTER,
});
